<template>
  <ButtonIcon :id="container_id" :path="path">
    <PencilIcon class="h-5 w-5 text-black/50 inline-flex" />
  </ButtonIcon>
</template>

<script>
import ButtonIcon from "@/components/buttons/ButtonIcon.vue";
import { PencilIcon } from "@heroicons/vue/24/solid";
export default {
  components: {
    ButtonIcon,
    PencilIcon,
  },
  props: {
    container_id: {
      type: String,
      default: "",
    },
    path: {
      type: String,
      default: "/",
    },
  },
};
</script>
